import React, { Fragment } from "react";
// core components
import { makeStyles } from "@material-ui/core/styles";

import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";

import logo from "assets/img/logo192.png";
import logo1 from "assets/img/bid_lab.jpg";
import logo2 from "assets/img/Citi.jpg";
import logo3 from "assets/img/Logohorizontal.jpg";
import logo4 from "assets/img/marketing-digital-quito-aei.jpg";
import logo5 from "assets/img/marketing-digital-quito-fundacion-avina.jpg";
import logo6 from "assets/img/resilient.jpg";

import FormInsert from "views/BusinessNetworks/FormBusinessNetworks";

import { cardStyle } from "assets/jss/material-dashboard-react/components/cardStyle";

const useStyles = makeStyles(cardStyle);

export default function FormBusinessNetworks() {
  const classes = useStyles();

  return (
    <Fragment>
      <GridContainer>
        <GridItem xs={12} sm={12} md={2}></GridItem>
        <GridItem xs={12} sm={12} md={8}>
          <Card>
            <center>
              <img
                src={logo}
                alt="validate"
                style={{
                  marginTop: 50,
                  width: 200,
                  height: 120,
                  objectFit: "cover",
                }}
              />
            </center>
            <CardBody>
              <div className={classes.titleCard}>
                Plataforma tecnológica ganadora de la convocatoria Quito
                Resiliente
              </div>
              <div className={classes.titleCardSub}>
                PRE-REGISTRO
              </div>
              {/*<div className={classes.titleCardSub}>
              En menos de un minuto sé parte de la red de negocios inteligentes de Guayaquil.
              </div>*/}
              <GridContainer
                style={{ marginTop: 20, padding: " 15px 15px 0px 15px" }}
              >
                <GridItem xs={12} md={12}>
                  <center>
                    {" "}
                    <b>Con el apoyo de:</b>{" "}
                  </center>
                </GridItem>
                <GridItem xs={6} md={2}>
                  <center>
                    {" "}
                    <img
                      src={logo1}
                      alt="logo1"
                      style={{
                        width: 125,
                      }}
                    />
                  </center>
                </GridItem>
                <GridItem xs={6} md={2}>
                  <center>
                    <img
                      src={logo2}
                      alt="logo2"
                      style={{
                        width: 115,
                      }}
                    />
                  </center>
                </GridItem>
                <GridItem xs={6} md={2}>
                  <center>
                    <img
                      src={logo3}
                      alt="logo3"
                      style={{
                        width: 130,
                      }}
                    />
                  </center>
                </GridItem>
                <GridItem xs={3} md={2}>
                  <center>
                    <img
                      src={logo4}
                      alt="logo4"
                      style={{
                        width: 130,
                      }}
                    />
                  </center>
                </GridItem>
                <GridItem xs={6} md={2}>
                  <center>
                    {" "}
                    <img
                      src={logo5}
                      alt="logo5"
                      style={{
                        width: 125,
                      }}
                    />
                  </center>
                </GridItem>
                <GridItem xs={6} md={2}>
                  <center>
                    {" "}
                    <img
                      src={logo6}
                      alt="logo6"
                      style={{
                        width: 125,
                      }}
                    />
                  </center>
                </GridItem>
              </GridContainer>
              <FormInsert />
            </CardBody>
            <CardFooter> </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={12} md={2}></GridItem>
      </GridContainer>
    </Fragment>
  );
}
